import React, { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import LoadingSpinner from '../../../../components/LoadingSpinner'
import FormModal from '../../../../shared/components/FormModal'

interface NonArrivedMovementReleaseModalProps {
  show: boolean
  onClose: () => void
  onSubmit: (explanation: string) => void
  isSubmitting: boolean
  isError: boolean
}

interface NonArrivedMovementReleaseForm {
  explanation: string
}

function NonArrivedMovementReleaseModal({
  show,
  onClose,
  onSubmit,
  isSubmitting,
  isError,
}: NonArrivedMovementReleaseModalProps) {
  const [form, setForm] = useState<NonArrivedMovementReleaseForm>({
    explanation: '',
  })

  const { t } = useTranslation()

  const submitForm = () => {
    onSubmit(form.explanation)
  }

  useEffect(() => {
    if (isError) {
      toast.error('Error occurred when sending non-arrived movement release')
    }
  }, [isError])

  return (
    <FormModal show={show} title={t('declaration.p5.nonArrivedMovementRelease', { context: 'title' })} onClose={onClose}>
      <div className="d-flex flex-column align-self-center w-100 mb-1">
        <p>{t('declaration.p5.nonArrivedMovementRelease')}</p>
        <textarea
          placeholder={t('declaration.p5.nonArrivedMovementRelease', { context: 'explanation' })}
          className="w-100 form-control mb-2"
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setForm({
            ...form,
            explanation: e.target.value,
          })}
        />
      </div>
      <div className="d-flex align-content-end justify-content-end mt-5">
        <button
          type="button"
          className="btn btn-lg btn-primary mx-1 text-black shadow-sm"
          onClick={submitForm}
          disabled={isSubmitting || form.explanation === ''}
        >
          {
            isSubmitting && <LoadingSpinner />
          }
          {
            !isSubmitting && (<span>{t('buttons.submit')}</span>)
          }
        </button>
      </div>
    </FormModal>
  )
}

export default NonArrivedMovementReleaseModal
